export const locale = {
  lang: 'es',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡FELICIDADES, HA LLEGADO AL FINAL DEL PROCESO DE CONFIGURACIÓN!',
      'INDICACION':'Para que su encuesta quede activa y lista para ser aplicada en las fechas configuradas, deberá dar clic en el botón activar encuesta',
      'CONFIRMAR':'Activar encuesta',
      'CERRAR-CONFIRMAR':'Desactivar encuesta',
      'IND_CONFIRM_JP': 'Antes de continuar con la activación de la encuesta, es  necesario confirmar la información previamente configurada.',
      'BTN_CONFIRM_INFO': 'Confirmar información ',
      'IND_ESP_CONFIRM_JP':'Una vez que el jefe de proyecto confirme, procederemos a activar la encuesta.',
      'MOD_TIT_CONGR_CONF':'Gracias por su confirmación',
      'MOD_ESP_CONFIRM_JP':'Únicamente falta la aprobación del jefe de proyecto para poder proceder con la activación de la encuesta.',
      'MESSAGE5':'Encuesta activa y lista para ser aplicada',
      'HISTORY_ACTIVATION_1': 'Última activación/desactivación',
      'HISTORY_ACTIVATION_2': 'Historial de activación:',
      'ESTATUS_SURVEY':{
        '0':'Desactivada',
        '1':'Activada',
        '2':'Cerrada',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>Para continuar la activación de la encuesta',
          // 'MESSAGE2':',ingrese el texto en rojo en la caja de texto</span>',
          'MESSAGE1':'<span> Para continuar con la activación de la encuesta, ingrese el texto en rojo en la caja de texto: ',
          'MESSAGE2':'</span>',
          'SALIR': 'Cancelar',
          'VALIDAR': 'Confirmar',
          'ERRORNOMBREEMPRESA': 'El texto ingresado, no coincide con el texto indicado en rojo',
          'SUCCES': 'Se activó la encuesta',
          'CERRAR': 'Cerrar',
          'SUCCES-DES': 'Se desactivó la encuesta',
          'MESSAGE3':'<span> Para continuar con la desactivación de la encuesta, ingrese el texto en rojo en la caja de texto: ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'Actualmente la encuesta ya cuenta con resultados, ¿Está seguro de desactivarla?',
          'MESSAGE6':'Actualmente no existe una encuesta',
          'BTN-ACEPTAR': 'Aceptar',
          'BTN-CANCELAR': 'Cancelar',
          'BTN-OK': 'Ok',
          'HORAMINIMA': 'No se pudo confirmar la comunicación por correo electrónico, la fecha del primer correo a enviar (lanzamiento o primer aviso, según el caso) tiene que ser posterior a dos horas a partir de este momento\n\nDe ser necesario, establezca nuevamente las fechas'
        },
      },
      'MODAL_CONFIRMACION': {
        'TITULO': 'Confirmación de datos',
        'INFO_1': 'Le informamos que debe confirmar la información de su producto antes de continuar con la activación de la encuesta. Le proporcionamos a continuación los detalles de su empresa y producto.',
        'INFO_2': 'Si la información es correcta, haga clic en el botón de <b>Confirmar</b>, en caso contrario, comuníquese con su Jefe de Proyecto para realizar una revisión.',
        'TABLA': {
          'TITULOS': {
            'clave': 'Nombre del campo',
            'valor': 'Valor actual'
          },
          'CAMPOS': {
            'company_name': 'Nombre de la empresa',
            'short_name': 'Nombre corto',
            'publication_name': 'Nombre de publicación',
            'company': 'Logo de la empresa',
            'certificate': 'Logo del certificado',
            'foundation_year': 'Año de fundación',
            'fullTime_employees': 'Número de colaboradores de tiempo completo',
            'parcial_employees': 'Número de colaboradores de tiempo parcial',
            'total_employees': 'Total de colaboradores',
            'sector': 'Sector',
            'sub_sector': 'Subsector',
            'rankig_type': 'Tipo de ranking',
            'ranking_name': 'Nombre de ranking',
            'name_RH': 'Nombre del responsable de RH',
            'email_RH': 'Correo electrónico del responsable de RH',
            'tel_RH': 'Teléfono del responsable de RH',
            'ext_RH': 'Extensión del responsable de RH',
            'cel_RH': 'Número celular del responsable de RH',
            'state': 'Estado',
            'multinational_group': 'Nombre del grupo multinacional',
            'country_application': 'País de aplicación',
          }
        }
      }
    },
  }
};
